import Api from '.'
import { BaseUrl } from './base_url_enum'

import { ILoginApiResponse, ILoginApiSuccessResponse, IManagedByUserResponse } from './types/login_api'

export const getResourceAuthorization = async (): Promise<ILoginApiResponse<ILoginApiSuccessResponse>> =>
  await Api('GET', 'resource-authorization', BaseUrl.Login)

export const getResourceAuthorizationsManagedByUser = async (userId: number): Promise<ILoginApiResponse<IManagedByUserResponse[]>> =>
  await Api('GET', 'resource-authorization/managed-by-user', BaseUrl.Login, { userId })

export const changeCurrentResourceAuthorization = async (relationNumber: number): Promise<ILoginApiResponse<ILoginApiSuccessResponse>> =>
  await Api('POST', 'resource-authorization/change', BaseUrl.Login, {
    relationNumber
  })

export const addResourceAuthorization = async (combiNumber: number, email: string): Promise<ILoginApiResponse<unknown>> =>
  await Api('POST', 'resource-authorization/add', BaseUrl.Login, {
    combiNumber,
    email
  })

export const verifyAddResourceAuthorization = async (
  email: string,
  relationNumber: number,
  addResourceAuthToken: string
): Promise<ILoginApiResponse<ILoginApiSuccessResponse>> =>
  await Api('POST', 'resource-authorization/verify', BaseUrl.Login, {
    email,
    relationNumber,
    addResourceAuthToken
  })

export const deleteResourceAuthorization = async (resourceAuthorizationId: number): Promise<ILoginApiResponse<ILoginApiSuccessResponse>> =>
  await Api('DELETE', `resource-authorization/${resourceAuthorizationId}`, BaseUrl.Login)
